module.exports = __webpack_public_path__ + "img/item_robot.9662fea1.svg";